import ui from './app.config/ui';

export default defineAppConfig({
  title: 'Hello Nuxt',
  theme: {
    dark: true,
    colors: {
      primary: '#ff0000',
    },
  },
  icon: {
    mode: 'svg', // Use SVG mode to eliminate separate CSS file for icons
  },
  ui,
});
